import { useEffect, useState } from 'react';
import { differenceInHours, getMinutes, getSeconds } from 'date-fns';

const calculateTimeLeft = (date: string | number | Date, delta: number) => {
  const formatDate = date instanceof Date ? date : new Date(date);
  const now = Date.now() + delta;

  const diff = formatDate.getTime() - now;
  const hour = differenceInHours(formatDate, now);
  const min = getMinutes(diff);
  const sec = getSeconds(diff);

  return Number.isNaN(diff) || diff < 0
    ? { hour: 0, min: 0, sec: 0 }
    : { hour, min, sec };
};

export const useRemainingTimeTimer = (
  date: string | number | Date,
  delta = 0,
  delay = 1000,
): Record<string, number> => {
  const [{ hour, min, sec }, setTime] = useState(calculateTimeLeft(date, delta));

  useEffect(() => {
    setTime(calculateTimeLeft(date, delta));
  }, [date, delta]);

  const tick = () => {
    setTime(calculateTimeLeft(date, delta));
  };

  useEffect(() => {
    let interval: number;
    if (hour > 0 || min > 0 || sec >= 0) {
      interval = window.setInterval(() => tick(), delay);
    }

    return () => clearInterval(interval);
  });

  return { hour, min, sec };
};
